import { gql } from '@apollo/client';

export const CreateReportReviewNote = gql`
  mutation createReportReviewNote(
    $jobId: Int!
    $typeQuestionId: Int!
    $type: String!
    $typeId: Int!
    $typeVersionId: Int!
    $note: String!
    $noteHtml: String!
    $isExternal: Boolean
  ) {
    createReportReviewNote(
      jobId: $jobId
      typeQuestionId: $typeQuestionId
      type: $type
      typeId: $typeId
      typeVersionId: $typeVersionId
      note: $note
      noteHtml: $noteHtml
      isExternal: $isExternal
    ) {
      reportReviewNote {
        id
      }
    }
  }
`;

export const UpdateReportReviewNote = gql`
  mutation updateReportReviewNote(
    $id: Int!
    $note: String!
    $noteHtml: String!
    $isExternal: Boolean
  ) {
    updateReportReviewNote(
      id: $id
      note: $note
      noteHtml: $noteHtml
      isExternal: $isExternal
    ) {
      reportReviewNote {
        id
      }
    }
  }
`;

export const CreateReportReviewComment = gql`
  mutation createReportReviewComment(
    $reportReviewNoteId: Int!
    $comment: String!
    $commentHtml: String!
  ) {
    createReportReviewComment(
      reportReviewNoteId: $reportReviewNoteId
      comment: $comment
      commentHtml: $commentHtml
    ) {
      reportReviewComment {
        id
      }
    }
  }
`;

export const UpdateReportReviewComment = gql`
  mutation updateReportReviewComment(
    $id: Int!
    $comment: String!
    $commentHtml: String!
  ) {
    updateReportReviewComment(
      id: $id
      comment: $comment
      commentHtml: $commentHtml
    ) {
      reportReviewComment {
        id
      }
    }
  }
`;

export const DeleteReportReviewComment = gql`
  mutation deleteReportReviewComment(
    $id: Int!
  ) {
    deleteReportReviewComment(
      id: $id
    ) {
      success
    }
  }
`;

export const DeleteReportReviewNote = gql`
  mutation deleteReportReviewNote(
    $id: Int!
  ) {
    deleteReportReviewNote(
      id: $id
    ) {
      success
    }
  }
`;

export const UpdateReportReviewNoteStatus = gql`
  mutation updateReportReviewNoteStatus($id: Int!, $close: Boolean!) {
    updateReportReviewNoteStatus(id: $id, close: $close) {
      reportReviewNote {
        id
      }
    }
  }
`;
